import { useEffect, useState } from 'react';

var timer:any

interface useTimeleftProps {
  onTimeout?:()=>void
}

function useTimeleft(time:number,props?:useTimeleftProps) {

  const [timeLeft,setTimeLeft] = useState<number>(0)
  const [start,setStart] = useState(false)

  useEffect(()=>{
    if (start) {
      timer = setInterval(()=>{
        if (start) {
            setTimeLeft((timeLeft)=>Math.max(timeLeft-1,0))
          }
      },1000)
    }
    if (!start) {
      clearInterval(timer)
    }
    return () => {
      clearInterval(timer)
    }
  },[start])

  useEffect(()=>{
    if (timeLeft <= 0) {
      clearInterval(timer)
      if (start) {
        setStart(false)
        if (props && props.onTimeout) props.onTimeout()
      }
    }
    // eslint-disable-next-line
  },[timeLeft,props])

  const startCount = () => {
    setStart(true)
  }

  const pauseCount = () => {
    setStart(false)
  }

  const resetCount = () => {
    setStart(false)
    setTimeLeft(0)
  }

  const restartCount = (localTime?:number) => {
    setStart(true)
    if (localTime) setTimeLeft(localTime)
    else setTimeLeft(time)
  }

  return ({
    timeLeft:timeLeft,
    startCount:startCount,
    pauseCount:pauseCount,
    resetCount:resetCount,
    restartCount:restartCount,
  })
}

export default useTimeleft